import { downloadPdfBlob } from '@/shared/api/pdf-download.api';

/**
 * Download an audience conversation as a server-rendered PDF blob via the
 * per-resource endpoint `GET /audience-sessions/:contextId/pdf` (headless
 * Chromium). Nothing is persisted — the print page reads the live transcript
 * snapshot by contextId, so no artifact is minted.
 */
export const downloadConversationPdf = (
  contextId: string,
  { workspaceId }: { workspaceId: string },
): Promise<Blob> =>
  downloadPdfBlob('audience-sessions', contextId, {
    // eslint-disable-next-line i18next/no-literal-string -- interpolated into the diagnostic `pdf-download.api.ts` throws; the caller toasts its own translated message
    label: 'Conversation',
    params: { workspaceId },
  });
